var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDocument = function SvgIconDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.415,
    height: 62.389,
    viewBox: "0 0 47.415 62.389",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.313 -3.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.565,19.37H37.758a.772.772,0,0,0,.78-.78h0a4.616,4.616,0,0,0-1.669-3.572L24.969,5.1a5.009,5.009,0,0,0-3.213-1.154h0A1.152,1.152,0,0,0,20.6,5.1V16.407A2.962,2.962,0,0,0,23.565,19.37Z",
    transform: "translate(16.19 0.009)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.736,16.415V3.938H12.3A5.006,5.006,0,0,0,7.313,8.929V61.335A5.006,5.006,0,0,0,12.3,66.326H49.737a5.006,5.006,0,0,0,4.991-4.991v-37.9H39.755A7.029,7.029,0,0,1,32.736,16.415Z",
    transform: "translate(0 0)",
    fill: "#f6c866"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-document.9fd3246e.svg";
export { ForwardRef as ReactComponent };